module.exports = __webpack_public_path__ + "static/media/hack-rpg-2.f62c42ef.jpeg";